module.exports = __webpack_public_path__ + "static/media/dashboard-img.434a8f0d.png";